// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__TYhBh","logo":"NotFound_logo__YB3yf","title":"NotFound_title__IDS1b","subtitle":"NotFound_subtitle__Rux2t"};